import classNames from 'classnames';

import s from './Heading.module.scss';

/*
  Heading Sizes weight/size/line-height
  400 / 24 / 32 - Loan Header i.e. Smith-Green
  400 / 16 / 24 - Page Summary i.e. Loan Documents, Sidebar menu item
  400 / 18 / 26 - Sidebar Section i.e. Authorized Contacts
  700 / 14 / 22 - Subcomment i.e. J Green title
  400 / 14 / 22 - Menu item for sub navigation

  Body Sizes weight/size/line-height
  400 / 14 / 22 - Subtitle on loan summary page
  400 / 16 / 24 - Text under page title
  400 / 12 / 20 - Caption text

  Styles
  Primary: bark4
  Secondary: bark3
  Alt-secondary; maple4
*/

type HeadingProps = {
  level: 1 | 2 | 3 | 4 | 5;
  variant?: 'primary' | 'secondary';
  bold?: boolean;
  className?: string;
  children: React.ReactNode;
};
export const Heading = ({ level, variant = 'primary', bold = true, children, className }: HeadingProps) => {
  return (
    <div
      className={classNames(
        'd-flex align-items-center gap-2',
        {
          [s.h1]: level === 1,
          [s.h2]: level === 2,
          [s.h3]: level === 3,
          [s.h4]: level === 4,
          [s.h5]: level === 5,
          'u-color-bark4': variant === 'primary',
          'u-color-maple4': variant === 'secondary',
          'fw-bold': bold,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
